import { ACCOUNT_TYPE, APPLICATION_TYPE } from '../../constants/sessionStorage';
import { ACCOUNT_TYPES } from '../constants';
import { applicationTypeStringHelper } from './applicationTypeStringHelper';
import { storeInSessionStorage } from './sessionStorageHelper';

export const accountTypeHelper = (ApplicationType, Application) => {
  if (ApplicationType) {
    const applicationTypeString = applicationTypeStringHelper(ApplicationType);

    if (applicationTypeString) {
      if (applicationTypeString === 'undefinedApplication') return;

      storeInSessionStorage(APPLICATION_TYPE, applicationTypeString);
      const accountData = Application[applicationTypeString];

      if (accountData && applicationTypeString && accountData?.AccountType) {
        const accountTypeString =
          ACCOUNT_TYPES[applicationTypeString][accountData?.AccountType];

        if (accountTypeString) {
          storeInSessionStorage(ACCOUNT_TYPE, accountTypeString);
        }
      }
    }
  }
};
